import { auth } from "@api/auth/api";
import { availablePlanYears } from "@api/availablePlanYears/api";
import { files } from "@api/files/api";
import { filters } from "@api/filters/api";
import { geo } from "@api/geo/api";
import { installments } from "@api/installments/api";
import { measurementUnitKinds } from "@api/measurementUnitKinds/api";
import { orderings } from "@api/orderings/api";
import { planKinds } from "@api/planKinds/api";
import { productPlans } from "@api/productPlans/api";
import { selectTypes } from "@api/selectTypes/api";
import { generalStats } from "@api/stats/api";
import { stores } from "@api/stores/api";
import { subscriptions } from "@api/subscriptions/api";
import { test } from "@api/test/api";
import { users } from "@api/users/api";

export const api = {
  users,
  files,
  geo,
  auth,
  selectTypes,
  filters,
  test,
  generalStats,
  productPlans,
  availablePlanYears,
  stores,
  subscriptions,
  installments,
  planKinds,
  orderings,
  measurementUnitKinds,
};
